import React, { memo } from  'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { PollenGauge } from './pollenGauge.js';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

export const PollenCount = memo(({pollenColor, pollenIndex, pollenDescription, predominantPollen, poweredByPollenLink }) => {
    return (
        <Container backgroundColor={pollenColor}>
            <PollenGauge pollenIndex={pollenIndex} />
            <TextContent>
                <DescriptionContent>
                    {pollenDescription}
                </DescriptionContent>
                <PredominantContent>
                    {predominantPollen}
                </PredominantContent>
            </TextContent>
            <PoweredByPollenAnchor href={poweredByPollenLink} target='_blank' rel='noopener noreferrer'>
                <img alt='Powered by Pollen' src='/images/powered_by_pollen.png' />
            </PoweredByPollenAnchor>
        </Container>
    );
});

PollenCount.displayName = 'PollenCount';
PollenCount.propTypes = {
    pollenColor: PropTypes.string,
    pollenIndex: PropTypes.number,
    pollenDescription: PropTypes.string,
    predominantPollen: PropTypes.string,
    poweredByPollenLink: PropTypes.string
};

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    height: 84px;
    width: 100%;
    border-radius: 2px;
    background-color: ${({backgroundColor}) => backgroundColor};

    @media ${smallMediaQuery} {
        justify-content: left;
        padding-left: 30px;
    }
`;

const TextContent = styled.div`
    text-align: left;
`;

const DescriptionContent = styled.div`
    margin-left: 14px;
    font-family: SourceSansPro-SemiBold, Source Sans Pro, sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
`;

const PredominantContent = styled.div`
    font-family: SourceSansPro-Regular, Source Sans Pro, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,0.75);
    margin-top: 2px;
    margin-left: 14px;
`;

const PoweredByPollenAnchor = styled.a`
    position: absolute;
    top:  50px;
    right: 10px;
`;

